import Phaser from 'phaser'

export const PHASER_EVENTS = {
    FRIEND_REQUEST_RECEIVED: 'friend_request_received',
    FRIEND_REQUEST_ACCEPTED: 'friend_request_accepted',
    BONE_RECEIVED: 'bone_received',
    BONE_COLLECTED: 'bone_collected',
    REWARD_COLLECTED: 'reward_collected',
    BUY_OPEN_PACK: 'buy_open_pack',
    LOBBY_UPDATE: 'lobby_update',
    TOURNAMENT_UPDATE: 'tournament_update',
    NOTIFICATION: 'general_notification',
    CHAT_NOTIFICATION: 'chat_notification',
    SOCKET_CONNECTED: 'socket-connected',
    SOCKET_RECONNECTED: 'socket-reconnected',
    CONNECTION_FAILED: 'connection-failed',
    MATCH_RESULT: 'match-result',
    REFRESH_LOBBY: 'refresh-lobby',
    LOBBY_MATCH_EVENT: 'lobby-match-event',
    PAYMENT_SUCCESS: 'payment-success', // x402 payment success (code 1001)
    PAYMENT_AUTHORIZED: 'payment-authorized', // x402 payment authorized in MetaMask
}
//console.log('PHASER_EVENTS', PHASER_EVENTS)
const eventsCenter = new Phaser.Events.EventEmitter();

export default eventsCenter